import { CommonModule } from '@angular/common';
import { BaseTitleComponent } from '../base-title/base-title.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admin-third-title',
  templateUrl: './third-title.component.html',
  styleUrls: ['./third-title.component.scss'],
  imports: [CommonModule],
})
export class ThirdTitleComponent extends BaseTitleComponent implements OnInit {
  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }
}
